<template>
  <content-view>
    <div slot="header"></div>
    <div class="wrap-container-in text-center">
      暂无内容，请先浏览其他页面~
    </div>
  </content-view>
</template>

<script type="text/javascript">
export default {
  name: "home",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss">
</style>